import React, { setState, useState, useEffect, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import moment from "moment";
import styles from "./OrderSheet.module.css";
import { makeStyles, useTheme, alpha } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { useLocation } from "react-router-dom";
import { getInvoicesByUser } from "../../actions/invoiceActions";
import { getProfilesByUser } from "../../actions/profile";
import Spinner from "../Spinner/Spinner";
import { useSnackbar } from "react-simple-snackbar";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { ReactGrid } from "@silevis/reactgrid";
import "@silevis/reactgrid/styles.css";
import axios from "axios";
import { saveAs } from "file-saver";
import ProgressButton from "react-progress-button";
import { useMediaQuery } from "@material-ui/core";
import { formatDollarsToCents, formatCentsToDollars, dollarFormatter } from "../../utils/money";

const WALK_UP_FEES = {
  "3rd floor": 8,
  "4th floor": 12,
  "5th floor": 18,
  "6th floor": 22,
};
const getWalkUpFee = (walkUp) => WALK_UP_FEES[walkUp] || 0;

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

const OrderSheet = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const invoicesState = useSelector((state) => state.invoices || {});
  const invoices = invoicesState?.invoices || [];
  const invoicesLoading = invoicesState?.isLoading;
  const user = JSON.parse(localStorage.getItem("profile"));
  const isLoading = useSelector((state) => state.routes.isLoading);
  // eslint-disable-next-line
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [sendStatus, setSendStatus] = useState(null);
  const [sendLawStatus, setSendLawStatus] = useState(null);
  const [selectedDate, setSelectedDate] = useState(() => {
    return moment().format("MM/DD/yyyy");
  });
  const [company, setCompany] = useState({});
  const [filteredInvoices, setFilteredInvoices] = useState(() => {
    return invoices.filter(
      (i) => moment(i.receivedByDate).format("MM/DD/yyyy") === selectedDate
    );
  });
  const [items, setItems] = useState([]);
  const [dnoItems, setDNOItems] = useState([]);
  const { profiles } = useSelector((state) => state.profiles);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));
  useEffect(() => {
        // get by userx
        // dispatch(getInvoicesByUser({search: user?.result._id || user?.result?.googleId}));
        // get white or invoice
        dispatch(getInvoicesByUser({search: false}));
    dispatch(
      getProfilesByUser({ search: user?.result?._id || user?.result.googleId })
    );
    // eslint-disable-next-line
  }, [location, dispatch]);

  useEffect(() => {
    setFilteredInvoices(() => {
      let filtered = invoices.filter((i) => {
        return moment(i.receivedByDate).format("MM/DD/yyyy") === selectedDate;
      });
      return filtered;
    });
  }, [selectedDate, invoices]);

  useEffect(() => {
    setItems(generateOrderSheet());
  }, [filteredInvoices]);

  useEffect(() => {
    setDNOItems(generateDNOSheet());
  }, [filteredInvoices]);
  


  const generateOrderSheet = () => {
    let productsMap = {};
    filteredInvoices.forEach((invoice) => {
      invoice.items.forEach((i) => {
        if (!i.doNotOrder) {
          if ((!productsMap.hasOwnProperty(i.modelNumber) && !i.lockup) || (!productsMap.hasOwnProperty(`#${i.modelNumber}`) && i.lockup)) {
            let pCost = dollarFormatter.format(i.unitCost);
            let pPrice = dollarFormatter.format(i.unitPrice);
            let pLockup = i.lockup ? `#${i.modelNumber}` : i.modelNumber
            productsMap[pLockup] = {
              quantity: i.quantity,
              cost: pCost,
              modelNumber: pLockup,
              price: pPrice
            };
          } else {
            let pLockup = i.lockup ? `#${i.modelNumber}` : i.modelNumber
            let quantity = parseInt(productsMap[pLockup]["quantity"]);
            productsMap[pLockup]["quantity"] = (
              quantity + parseInt(i.quantity)
            ).toString();
          }
        }
      });
    });
    return Object.keys(productsMap).map((key) => {
      return productsMap[key];
    });
  };

  const generateDNOSheet = () => {
    let productsMap = {};
    filteredInvoices.forEach((invoice) => {
      invoice.items.forEach((i) => {
        if (i.doNotOrder) {
          if (!productsMap.hasOwnProperty(i.modelNumber)) {
            let pCost = dollarFormatter.format(i.unitCost);
            let pPrice = dollarFormatter.format(i.unitPrice);
            productsMap[i.modelNumber] = {
              quantity: i.quantity,
              modelNumber: i.modelNumber,
              cost: pCost,
              price: pPrice
            };
          } else {
            let quantity = parseInt(productsMap[i.modelNumber]["quantity"]);
            productsMap[i.modelNumber]["quantity"] = (
              quantity + parseInt(i.quantity)
            ).toString();
          }
        }
      });
    });
    return Object.keys(productsMap).map((key) => {
      return productsMap[key];
    });
  };

  const sendOrderSheet = (e, emailList, flag) => {
    e.preventDefault();
    flag === 'L' ? setSendLawStatus("loading") : setSendStatus("loading");
    axios
      .post(`${process.env.REACT_APP_API}/pdfs/send-order-sheet`, {
        sentDate: moment().format("MM/DD/yyyy"),
        selectedDate: selectedDate,
        rows: items,
        email: emailList,
        flag: flag,
      })
      .then(() => {
        flag === 'L' ? setSendLawStatus("success") : setSendStatus("success");
      })
      .catch((error) => {
        console.log(error);
        flag === 'L' ? setSendLawStatus("error") : setSendStatus("error");
      });
  };

  const handleDateChange = (value) => {
    if (value !== null) {
      let val = moment(value).format("MM/DD/yyyy");
      setSelectedDate(val);
    }
  };

  if (!user) {
    history.push("/login");
  }

  const dnoHeaderRow = {
    rowId: 'dnoHeader',
    cells: [
      {
        type: "header",
        text: "Model #",
      },
      {
        type: "header",
        text: "Qty",
      },
    ]
  }

  const headerRow = {
    rowId: "header",
    cells: [
      {
        type: "header",
        text: "Model #",
      },
      {
        type: "header",
        text: "Qty",
      },
      {
        type: "header",
        text: "Cost",
      },
    ],
  };

  const headerReturnRow = {
    rowId: "returnsHeader",
    cells: [
      {
        type: "header",
        text: "Model #",
      },
      {
        type: "header",
        text: "Qty",
      },
      {
        type: "header",
        text: "Return",
      },
      {
        type: "header",
        text: "Ticket #",
      },
    ],
  }

  const mobileHeaderRow = {
    rowId: "header",
    cells: [
      {
        type: "header",
        text: "Model #",
      },
      {
        type: "header",
        text: "Qty",
      },
      {
        type: "header",
        text: "Cost",
      },
    ],
  };

  let totalCostCents = 0;
  let totalTaxCents = 0;
  let revenueCents = 0;
  let totalCost = "";
  let profit = "";
  let revenue = "";
  let totalTax = "";
  let revenueWithTax = "";
  
  const calculateTotal = () => {
    totalCostCents = 0;
    totalTaxCents = 0;
    revenueCents = 0;
    for (var i = 0; i < filteredInvoices.length; i += 1) {
      let invoice = filteredInvoices[i];
      const deliveryFeeCents = formatDollarsToCents(invoice.deliveryFee || 0);
      const haulAwayCents = invoice.haulAway ? formatDollarsToCents(40) : 0;
      const walkUpCents = formatDollarsToCents(getWalkUpFee(invoice.walkUp || ""));
      let lineRevenueCents = 0;
      totalCostCents += deliveryFeeCents + haulAwayCents + walkUpCents;
      totalTaxCents += formatDollarsToCents(invoice.salesTax || 0);
      for (var j = 0; j < invoice.items.length; j ++) {
        let item = invoice.items[j];
        if (!item.doNotOrder) {
          let qty = parseInt(item.quantity)
          let costCents = formatDollarsToCents(item.unitCost)
          totalCostCents += qty * costCents;
          let priceCents = formatDollarsToCents(item.unitPrice)
          lineRevenueCents += qty * priceCents;
        } else {
          let qty = parseInt(item.quantity)
          let costCents = formatDollarsToCents(item.unitCost)
          // inventory cost intentionally excluded
        }
      }
      revenueCents += lineRevenueCents + deliveryFeeCents + haulAwayCents + walkUpCents;
    }
    let profitCents = revenueCents - totalCostCents;
    const revenueWithTaxCents = revenueCents + totalTaxCents;
    profit = dollarFormatter.format(formatCentsToDollars(profitCents));
    revenue = dollarFormatter.format(formatCentsToDollars(revenueCents));
    revenueWithTax = dollarFormatter.format(formatCentsToDollars(revenueWithTaxCents));
    totalCost = dollarFormatter.format(formatCentsToDollars(totalCostCents));
    totalTax = dollarFormatter.format(formatCentsToDollars(totalTaxCents));
  };

  const getRows = () => {
    return [
      headerRow,
      ...items.map((p, index) => ({
        rowId: index,
        cells: [
          { type: "text", text: p.modelNumber },
          { type: "text", text: p.quantity },
          { type: "text", text: p.cost },
        ],
      })),
      {
        rowId: "totalTitle",
        cells: [
          { type: "text", text: "" },
          { type: "text", text: "" },
          { type: "text", text: `Totals` },
        ],
      },
      {
        rowId: "totalCost",
        cells: [
          { type: "text", text: "" },
          { type: "text", text: "" },
          { type: "text", text: `Cost: ${totalCost}` },
        ],
      },
      {
        rowId: "tax",
        cells: [
          { type: "text", text: "" },
          { type: "text", text: "" },
          { type: "text", text: `Tax: ${totalTax}` },
        ],
      },
      {
        rowId: "revenue",
        cells: [
          { type: "text", text: "" },
          { type: "text", text: "" },
          { type: "text", text: `Revenue: ${revenue}` },
        ],
      },
      {
        rowId: "revenueWithTax",
        cells: [
          { type: "text", text: "" },
          { type: "text", text: "" },
          { type: "text", text: `Total: ${revenueWithTax}` },
        ],
      },
      {
        rowId: "Profit",
        cells: [
          { type: "text", text: "" },
          { type: "text", text: "" },
          { type: "text", text: `Profit: ${profit}` },
        ],
      },
    ];
  };

  const getDNORows = () => {
    return [
      dnoHeaderRow,
      ...dnoItems.map((p, index) => ({
        rowId: index,
        cells: [
          { type: "text", text: p.modelNumber },
          { type: "text", text: p.quantity },
        ],
      })),
    ];
  }
  const getMobileRows = () => {
    return [
      mobileHeaderRow,
      ...items.map((p, index) => ({
        rowId: index,
        cells: [
          { type: "text", text: p.modelNumber },
          { type: "text", text: p.quantity },
          { type: "text", text: p.cost },
        ],
      })),
      {
        rowId: "totalTitle",
        cells: [
          { type: "text", text: "" },
          { type: "text", text: "" },
          { type: "text", text: `Totals` },
        ],
      },
      {
        rowId: "totalCost",
        cells: [
          { type: "text", text: "" },
          { type: "text", text: "" },
          { type: "text", text: `Cost: ${totalCost}` },
        ],
      },
      {
        rowId: "tax",
        cells: [
          { type: "text", text: "" },
          { type: "text", text: "" },
          { type: "text", text: `Tax: ${totalTax}` },
        ],
      },
      {
        rowId: "revenue",
        cells: [
          { type: "text", text: "" },
          { type: "text", text: "" },
          { type: "text", text: `Revenue: ${revenue}` },
        ],
      },
      {
        rowId: "revenueWithTax",
        cells: [
          { type: "text", text: "" },
          { type: "text", text: "" },
          { type: "text", text: `Total: ${revenueWithTax}` },
        ],
      },
      {
        rowId: "Profit",
        cells: [
          { type: "text", text: "" },
          { type: "text", text: "" },
          { type: "text", text: `Profit: ${profit}` },
        ],
      },
    ];
  };

  calculateTotal();

  const rows = getRows(items);
  const dnoRows = getDNORows(dnoItems);
  const mobileRows = getMobileRows(items);
  const cols = [
    { columnId: "modelNumber", width: 250 },
    { columnId: "quantity", width: 250 },
    { columnId: "cost", width: 250 },
  ];

  const dnoCols = [
    { columnId: "modelNumber", width: 250 },
    { columnId: "quantity", width: 100 },
  ]

  const mobileCols = [
    { columnId: "modelNumber", width: 150 },
    { columnId: "quantity", width: 75 },
    { columnId: "cost", width: 150 },
  ];

  const applyChanges = (changes, prev) => {
    changes.forEach((change) => {
      console.log(change);
      const rowIndex = change.rowId;
      const fieldName = change.columnId;
      if (change.type === 'dropdown') {
        if (change.newCell.selectedValue !== change.previousCell.selectedValue) {
          prev[rowIndex][fieldName] = change.newCell.selectedValue;
        }
        prev[rowIndex]['isOpen'] = change.newCell.isOpen;
      } else {
        prev[rowIndex][fieldName] = change.newCell.text;
      }
      
    });
    return [...prev];
  };

  const handleChanges = (changes) => {
    setItems((prev) => applyChanges(changes, prev));
  };

  const handleDNOChanges = (changes) => {
    setDNOItems((prev) => applyChanges(changes, prev));
  }

  const handleAddDNORowClick = () => {
    setDNOItems((prev) => {
      return [
        ...prev,
        {modelNumber: '', quantity: '0'}
      ]
    })
  }

  const handleAddRowClick = () => {
    setItems((prev) => {
      return [
        ...prev,
        { quantity: "0", cost: "$0.00", modelNumber: "" },
      ];
    });
  };

  const handleRemoveRowClick = (selectedRowIds) => {
    setItems((prev) => {
      return [...prev.filter((product, idx) => !selectedRowIds.includes(idx))];
    });
  };

  const dataLoading =
    ((invoicesLoading ?? false) && invoices.length === 0);

  if (isLoading || dataLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
        }}
      >
        <Spinner />
      </div>
    );
  }

  return (
    <Container
      style={{
        width: "100%",
        paddingTop: "70px",
        paddingBottom: "200px",
        minHeight: '100vh',
        border: "none",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div className="row">
      
        <div className="col-md-6 col-sm-12" style={{textAlign: 'center'}}>
          <h1>Order Sheet</h1>
          <div className={styles.buttons}>
            <button
              // disabled={status === 'Paid' ? true : false}
              className={styles.btn}
              onClick={() => handleAddRowClick()}
            >
              Add Row
            </button>
            <div className={styles.toolBar}>
              <Container>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="Filter By Received By Date"
                    format="MM/dd/yyyy"
                    value={selectedDate}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Container>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-sm-12"></div>
      </div>

      {/* <span>
        Products are displayed from invoices:{" "}
        {filteredInvoices.map((i) => {
          return `${i.invoiceNumber}, `;
        })}
      </span> */}
      
       {
        !matches ?
            <ReactGrid
              rows={mobileRows}
              columns={mobileCols}
              onCellsChanged={handleChanges}
              enableRowSelection
            ></ReactGrid>
            :
            <ReactGrid
              rows={rows}
              columns={cols}
              onCellsChanged={handleChanges}
              enableRowSelection
            ></ReactGrid>
       }
    </Container>
  );
};

export default OrderSheet;
